import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { ArrowBack, NewIconActive, NewIconDefault } from "../../assests/images";
import { InformationTab } from "../../components/create-request/information-tab";
import { CreateRequestType } from "../../utility/enums/create-request";
import { IInformationTab } from "../../utility/interfaces/common/info-tabs";
import { useNavigate } from "react-router-dom";
import { AppRoutings } from "utility/enums/app-routings";

const CreateRequest: React.FC = () => {
  // Page level variables
  const navigate = useNavigate();
  const informationTabs: IInformationTab[] = [
    {
      id: 1,
      type: CreateRequestType.patient,
      defaultIcon: NewIconDefault,
      activeIcon: NewIconActive,
      title: "Patient",
      class: "new",
    },
    {
      id: 2,
      type: CreateRequestType.familyOrFriend,
      defaultIcon: NewIconDefault,
      activeIcon: NewIconActive,
      title: "Family/Friend",
      class: "working",
    },
    {
      id: 3,
      type: CreateRequestType.concierge,
      defaultIcon: NewIconDefault,
      activeIcon: NewIconActive,
      title: "Concierge",
      class: "active",
    },
    {
      id: 4,
      type: CreateRequestType.businessPartners,
      defaultIcon: NewIconDefault,
      activeIcon: NewIconActive,
      title: "Business Partners",
      class: "conclude",
    },
  ];
  // useStates
  const [currentSelectedTab, setCurrentSelectedTab] = useState(0);

  // Handled events and functions
  const handleOnBackButtonClick = () => {
    if (currentSelectedTab === 0) navigate(AppRoutings.Root);
    else setCurrentSelectedTab(0);
  };
  const handleTabChange = (tab: IInformationTab) => {
    switch (tab.type) {
      case CreateRequestType.patient:
        navigate(AppRoutings.PatientRequest);
        break;
      case CreateRequestType.familyOrFriend:
        navigate(AppRoutings.FamilyFriendRequest);
        break;
      case CreateRequestType.concierge:
        navigate(AppRoutings.ConciergeRequest);
        break;
      case CreateRequestType.businessPartners:
        navigate(AppRoutings.BusinessRequest);
        break;
      default:
        setCurrentSelectedTab(tab.type);
        break;
    }
  };

  return (
    <>
      <main className="main-content">
        <div
          className="overlay"
          onClick={(e) => document.body.classList.toggle("sidebar-toggle")}
        ></div>

        <Box className="request-container-box">
          <div className="request-header">
            <div></div>
            {currentSelectedTab === 0 && (
              <Typography variant="h1" fontWeight={600}>
                I am a...
              </Typography>
            )}
            <Button onClick={handleOnBackButtonClick} variant="outlined">
              <img src={ArrowBack} alt="arrow" />
              Back
            </Button>
          </div>
          {/* <div className="request-header">
            <Typography variant="h5">I am a...</Typography>
          </div> */}
          {currentSelectedTab === 0 && (
            <InformationTab
              tabs={informationTabs}
              currentTabValue={currentSelectedTab}
              handleTabChange={handleTabChange}
              repeatSequence={4}
            />
          )}
        </Box>
      </main>
    </>
  );
};

export default CreateRequest;
